<template>
  <div class="oct-salon-dashboard">
    <section class="oct-salon-dashboard-summary">
      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">スタイル送信数</span>
        <span class="oct-salon-dashboard-summary-item__value">936</span>
      </div>

      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">ユニーク顧客数</span>
        <span class="oct-salon-dashboard-summary-item__value">438</span>
      </div>

      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">スタイル閲覧数</span>
        <span class="oct-salon-dashboard-summary-item__value">115</span>

        <div class="oct-salon-dashboard-summary-item__meta">
          <span class="oct-salon-dashboard-summary-item__caption">閲覧率: 12.3%</span>
          <span class="oct-salon-dashboard-summary-item__caption">送信→閲覧: 平均13.2日</span>
        </div>
      </div>

      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">カート追加数</span>
        <span class="oct-salon-dashboard-summary-item__value">5</span>

        <div class="oct-salon-dashboard-summary-item__meta">
          <span class="oct-salon-dashboard-summary-item__caption">追加率: 4.3%</span>
          <span class="oct-salon-dashboard-summary-item__caption">閲覧→カート: 平均-21.3日</span>
        </div>
      </div>
      
      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">購入件数（購入者数）</span>
        <span class="oct-salon-dashboard-summary-item__value">5（5）</span>

        <div class="oct-salon-dashboard-summary-item__meta">
          <span class="oct-salon-dashboard-summary-item__caption">購入率: 4.3%</span>
        </div>
      </div>

      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">売上金額</span>
        <span class="oct-salon-dashboard-summary-item__value">¥649,990</span>
      </div>
    </section>

    <section class="oct-salon-dashboard-trend">
      <div class="oct-salon-dashboard-header">
        <h2 class="oct-salon-dashboard-header__primary-text">
          トレンド
        </h2>

        <p class="oct-salon-dashboard-header__secondary-text">
          スタイル送信数・閲覧数・購入数の推移
        </p>
      </div>

      <div class="oct-salon-dashboard-trend-chart">
        <div class="oct-salon-dashboard-trend-chart-summary">
          <div class="oct-salon-dashboard-trend-chart-summary-item">
            <span class="oct-salon-dashboard-trend-chart-summary-item__label">スタイル送信数</span>
            <span class="oct-salon-dashboard-trend-chart-summary-item__value">936</span>
          </div>

          <div class="oct-salon-dashboard-trend-chart-summary-item">
            <span class="oct-salon-dashboard-trend-chart-summary-item__label">閲覧数</span>
            <span class="oct-salon-dashboard-trend-chart-summary-item__value">115</span>
          </div>

          <div class="oct-salon-dashboard-trend-chart-summary-item">
            <span class="oct-salon-dashboard-trend-chart-summary-item__label">購入件数</span>
            <span class="oct-salon-dashboard-trend-chart-summary-item__value">5</span>
          </div>

          <div class="oct-salon-dashboard-trend-chart-summary-item">
            <span class="oct-salon-dashboard-trend-chart-summary-item__label">スタイル閲覧率</span>
            <span class="oct-salon-dashboard-trend-chart-summary-item__value">12.3%</span>
          </div>
        </div>

        <div class="oct-salon-dashboard-trend-chart__container">
          <canvas id="acquisitions" />
        </div>
      </div>

    </section>

    <section class="oct-salon-dashboard-staff-performance">
      <div class="oct-salon-dashboard-header">
        <h2 class="oct-salon-dashboard-header__primary-text">
          スタッフ別パフォーマンス
        </h2>

        <p class="oct-salon-dashboard-header__secondary-text">
          スタッフごとの送信数・閲覧率・購入率・売上
        </p>
      </div>

      <div class="oct-salon-dashboard-staff-performance__slider">
        <table class="oct-salon-dashboard-staff-performance__table">
          <thead>
            <tr>
              <th>スタッフ</th>
              <th class="oct-salon-dashboard-staff-performance__role">役割</th>
              <th>送信数</th>
              <th>閲覧数</th>
              <th>カート追加数</th>
              <th>購入数</th>
              <th>購入者数</th>
              <th>売上</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <span class="oct-salon-dashboard-staff-performance__name">
                  <span class="oct-salon-dashboard-staff-performance__rank">
                    1
                  </span>
                  池澤大地
                </span>
              </td>
              <td>スタイリスト</td>
              <td>310</td>
              <td>40</td>
              <td>3</td>
              <td>4</td>
              <td>4</td>
              <td>¥344,740</td>
            </tr>

            <tr>
              <td>
                <span class="oct-salon-dashboard-staff-performance__name">
                  <span class="oct-salon-dashboard-staff-performance__rank">
                    2
                  </span>
                  梅原加子
                </span>
              </td>
              <td>スタイリスト</td>
              <td>308</td>
              <td>39</td>
              <td>3</td>
              <td>4</td>
              <td>4</td>
              <td>¥344,740</td>
            </tr>

            <tr>
              <td>
                <span class="oct-salon-dashboard-staff-performance__name">
                  <span class="oct-salon-dashboard-staff-performance__rank">
                    3
                  </span>
                  今岡凛也
                </span>
              </td>
              <td>スタイリスト</td>
              <td>306</td>
              <td>41</td>
              <td>3</td>
              <td>4</td>
              <td>4</td>
              <td>¥344,740</td>
            </tr>

            <tr>
              <td>
                <span class="oct-salon-dashboard-staff-performance__name">
                  池澤大地
                </span>
              </td>
              <td>スタイリスト</td>
              <td>293</td>
              <td>33</td>
              <td>3</td>
              <td>4</td>
              <td>4</td>
              <td>¥344,740</td>
            </tr>

            <tr>
              <td>
                <span class="oct-salon-dashboard-staff-performance__name">
                  梅原加子
                </span>
              </td>
              <td>スタイリスト</td>
              <td>280</td>
              <td>33</td>
              <td>3</td>
              <td>4</td>
              <td>4</td>
              <td>¥344,740</td>
            </tr>

            <tr>
              <td>
                <span class="oct-salon-dashboard-staff-performance__name">
                  今岡凛也
                </span>
              </td>
              <td>スタイリスト</td>
              <td>221</td>
              <td>25</td>
              <td>3</td>
              <td>4</td>
              <td>4</td>
              <td>¥344,740</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'OctSalonDashboard',
  props: {
  },
  methods: {
  },
  mounted() {
    const data = [
      { year: '12/1', count: 10 },
      { year: '1/1', count: 20 },
      { year: '2/1', count: 15 },
      { year: '3/1', count: 25 },
      { year: '4/1', count: 22 },
      { year: '5/1', count: 30 },
      { year: '6/1', count: 28 },
    ];

    new window.Chart(
      document.getElementById('acquisitions'),
      {
        type: 'bar',
        data: {
          labels: data.map(row => row.year),
          datasets: [
            {
              label: '送信数',
              data: data.map(row => row.count),
              categoryPercentage: .1,
              barPercentage: 1,
              maxBarThickness: 2,
              backgroundColor: '#10B4D5',
              borderColor: '#10B4D5',
              borderWidth: 2,
              order: 2,
            },
            {
              label: '閲覧数',
              data: data.map(row => row.count),
              categoryPercentage: .1,
              barPercentage: 1,
              maxBarThickness: 2,
              backgroundColor: '#FF3CD1',
              borderColor: '#FF3CD1',
              borderWidth: 2,
              order: 2,
            },
            {
              label: '購入数',
              data: data.map(row => row.count),
              categoryPercentage: .1,
              barPercentage: 1,
              maxBarThickness: 2,
              backgroundColor: '#1FD125',
              borderColor: '#1FD125',
              borderWidth: 2,
              order: 2,
            },
            {
              label: '閲覧率',
              data: data.map(row => row.count),
              type: 'line',
              yAxisID: 'y1',
              borderColor: '#723CFF',
              backgroundColor: '#723CFF',
              borderWidth: 2,
              order: 1,
            },
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              backgroundColor: '#FFFFFF',
              titleColor: '#000000',
              bodyColor: '#000000',
              boxWidth: 16,
              boxHeight: 0,
              boxPadding: 8,
              padding: 32,
            },
            legend: {
              position: 'bottom',
              align: 'start',
              labels: {
                padding: 16,
                boxWidth: 16,
                boxHeight: 2,
              },
            }
          },
          scales: {
            x: {
              grid: {
                display: false,
              }
            },
            y: {
              type: 'linear',
              position: 'left',
            },
            y1: {
              type: 'linear',
              display: true,
              position: 'right',
              min: 0,
              max: 100,
              ticks: {
                stepSize: 25,
              },
              grid: {
                drawOnChartArea: false
              }
            }
          },
          interaction: {
            mode: 'index',
            intersect: false,
          },
        },
      }
    );
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-salon-dashboard {
  display: flex;
  flex-direction: column;
  gap: oct-rem(64);
}

.oct-salon-dashboard-summary {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: oct-rem(16);
}

.oct-salon-dashboard-summary-item {
  display: flex;
  flex-direction: column;
  gap: oct-rem(16);
  padding: oct-rem(16);
  height: oct-rem(120);
  border: oct-rem(1) solid $oct-theme--neutral-20;
}

.oct-salon-dashboard-summary-item__label {
  font-size: oct-rem(12);
  line-height: 1;
  color: $oct-theme--neutral-50;
}

.oct-salon-dashboard-summary-item__value {
  font-size: oct-rem(20);
  font-weight: 600;
  line-height: 1;
}

.oct-salon-dashboard-summary-item__meta {
  display: flex;
  flex-direction: column;
  gap: oct-rem(4);
}

.oct-salon-dashboard-summary-item__caption {
  font-size: oct-rem(10);
  line-height: 1;
  color: $oct-theme--neutral-50;
}

.oct-salon-dashboard-header {
  display: flex;
  flex-direction: column;
  gap: oct-rem(16);
}

.oct-salon-dashboard-header__primary-text {
  font-size: oct-rem(20);
  font-weight: 600;
  line-height: 1;
  margin: 0;
}

.oct-salon-dashboard-header__secondary-text {
  font-size: oct-rem(14);
  line-height: 1;
  color: $oct-theme--neutral-50;
  margin: 0;
}

.oct-salon-dashboard-trend {
  display: flex;
  flex-direction: column;
  gap: oct-rem(32);
}

.oct-salon-dashboard-trend-chart {
  display: flex;
  flex-direction: column;
  gap: oct-rem(48);
  padding: oct-rem(32) 0 oct-rem(16);
  border: oct-rem(1) solid $oct-theme--neutral-20;
}

.oct-salon-dashboard-trend-chart-summary {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: oct-rem(16);
}

.oct-salon-dashboard-trend-chart-summary-item {
  display: flex;
  flex-direction: column;
  gap: oct-rem(8);
  padding: 0 oct-rem(16);
}

.oct-salon-dashboard-trend-chart-summary-item__label {
  font-size: oct-rem(12);
  line-height: 1;
  color: $oct-theme--neutral-50;
}

.oct-salon-dashboard-trend-chart-summary-item__value {
  font-size: oct-rem(20);
  font-weight: 600;
  line-height: 1;
}

.oct-salon-dashboard-staff-performance {
  display: flex;
  flex-direction: column;
  gap: oct-rem(32);
}

.oct-salon-dashboard-staff-performance__table {
  min-width: 100%;
  border-collapse: collapse;

  th, td {
    text-align: center;
    height: oct-rem(48);
    padding: 0 oct-rem(16);
    vertical-align: middle;
    min-width: oct-rem(72);

    &:first-child {
      padding-left: oct-rem(32);
    }

    &:last-child {
      padding-right: oct-rem(32);
    }
  }

  .oct-salon-dashboard-staff-performance__role {
    width: min-oct-rem(120);
  }

  th {
    font-size: oct-rem(12);
    line-height: 1;
    color: $oct-theme--neutral-50;
  }

  td {
    font-size: oct-rem(14);
    line-height: 1;
    border-top: oct-rem(1) solid $oct-theme--neutral-20;
  }
}

.oct-salon-dashboard-staff-performance__name {
  display: flex;
  align-items: center;
  gap: oct-rem(8);
}

.oct-salon-dashboard-staff-performance__rank {
  font-size: oct-rem(12);
  line-height: 1;
  color: $oct-theme--on-primary;
  display: flex;
  justify-content: center;
  align-items: center;
  width: oct-rem(18);
  height: oct-rem(24);
  border-radius: oct-rem(9);
  background-color: $oct-theme--neutral;
}

.oct-salon-dashboard-trend-chart__container {
  width: 100%;
  height: oct-rem(216);
  padding: 0 oct-rem(16);
}
</style>